import React, { Component } from 'react';
import { Tree, Input, Tooltip, Icon, Button, Table, Modal, message, Upload, Popconfirm, Select } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import './index.less';
import UpdateCatalog from './UpdateCatalog';
import moment from 'moment';
import ExportUtil from '../../../common/ExportUtil';
import { connect } from 'react-redux';
import { saveParams } from '../../../actions/PersonalActions';
import { saveParams as saveNoticeParams } from '../../../actions/noticeActions';
import UserSider from '../../user/UserSider';
import ApproveVitaeModal from './ApproveVitaeModal';

const TreeNode = Tree.TreeNode;
const Search = Input.Search;
const Option = Select.Option;

class File extends Component {
    state = {
        treeData: [],   //目录数据
        simplifyTreeData: [],
        tableData: [],  //表格数据
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
        expandedKeys: [],
        searchValue: '',
        autoExpandParent: true,
        fileList: [],
        selectedRowKeys: [],
        arry: [],
        clearArry: false,
        imageUrl: '',
        batchMarkData: [], //标记批量下载
        pathName: '', //路径名称
        maxSize: 0,
    }

    componentDidMount() {
        this.loadData();
        this.queryFileMax();
    }

    componentWillUnmount() {
        this.props.saveParams({
            folderUserId: undefined,
            folderUserName: undefined,
        });
        this.props.saveNoticeParams({
            userId: undefined,
            userName: undefined,
        });
        clearTimeout(this.timerId); // 组件卸载时清理定时器
    }

    loadData = () => {
        const { params: { folderUserId, folderUserName }, noticeParams: { userId, userName } } = this.props;
        
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.folder.queryCatalogTree,
            data: {
                userId: folderUserId || userId || sessionStorage.userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { catalogs = [] } = res;
                const { expandedKeys } = this.state;
                const expandedDefaultKeys = catalogs.map(el => String(el.id)); //默认展开目录
                const simplifyTreeData = this.flattenList(catalogs);
                const { children = [], catalogName: parentText } = catalogs[0] || {};
                const { catalogType, createUser, catalogName: sonText, id } = children[0] || {};
                const pathName = `${parentText}-->${sonText}`;
                this.setState({
                    loading: false,
                    treeData: catalogs,
                    pathName,
                    expandedKeys: expandedKeys.length ? expandedKeys : expandedDefaultKeys,
                    simplifyTreeData,
                    catalogId: id,
                    catalogType,
                    createUser,
                    userId: folderUserId || userId,  // userId有值的时候说明是从“人员文件夹”或“消息”进来的
                    userName: folderUserName || userName,
                }, () => {
                    this.queryTableData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    queryFileMax = () => {
        const options = {
            method: 'POST',
            url: API_URL.folder.queryFileMax,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { maxSize } = res;
                this.setState({
                    maxSize: Number(maxSize),
                })
            },
        };
        $.sendRequest(options);
    }

    //数组扁平化
    flattenList = list => {
        const result = [];
        // 递归遍历函数
        const traverse = (nodes) => {
            nodes.forEach((node) => {
                result.push({ ...node }); // 浅拷贝节点，避免修改原数据
                if (node.children) {
                    traverse(node.children);
                }
            });
        };
        traverse(list);
        return result;
    }

    queryTableData = () => {
        const { catalogId, catalogType, createUser, pagination, userId } = this.state;
        const { current, pageSize } = pagination;
        //folderUserId是人员文件夹跳转的id，userId是消息跳转的id
        if (!catalogId) {
            return
        }
        let vitaeType = '';
        let url = '';
        switch (catalogType) {
            case 'CHINESE_VITAE':
                vitaeType = 'CHINESE';
                url = API_URL.folder.queryVitaeList;
                break;
            case 'ENGLISH_VITAE':
                vitaeType = 'ENGLISH';
                url = API_URL.folder.queryVitaeList;
                break;
            case 'INVESTIGATON_TRAINING': //项目培训
                vitaeType = undefined;
                url = API_URL.folder.queryInvTrainList;
                break;
            case 'COV_INVESTIGATON_LEVEL': //COV项目层面
                vitaeType = undefined;
                url = API_URL.folder.queryInvCovList;
                break;
            case 'QC_INVESTIGATON_LEVEL':  //QC项目层面
                vitaeType = undefined;
                url = API_URL.folder.queryInvQcList;
                break;
            default: 
                vitaeType = undefined;  //文件查询列表
                url = API_URL.folder.queryFileManageList; 
                break;
        };
        //非预埋数据均调文件查询列表接口
        if (createUser !== -1) {
            vitaeType = undefined;
            url = API_URL.folder.queryFileManageList;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                offset: current,
                limit: pageSize,
                vitaeType,
                catalogId,
                userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { arry, clearArry } = this.state;
                const { filePage = {} } = res;
                const { datas = [], totalCount } = filePage;
                pagination.total = totalCount;
                datas.forEach((item, index) => item.index = (current - 1) * pageSize + index + 1);
                let newArry;
                const newSelectedRowKeys = [];
                if (clearArry) {
                    newArry = arry.filter(item => datas.some(innerItem => innerItem.id == item));
                } else {
                    newArry = arry;
                }
                newArry.forEach(item => {
                    const selectData = datas.find(innerItem => innerItem.id == item);
                    if (selectData) {
                        newSelectedRowKeys.push(selectData.index);
                    }
                });

                this.setState({
                    loading: false,
                    pagination,
                    tableData: datas,
                    arry: newArry,
                    selectedRowKeys: newSelectedRowKeys,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    downloadFileBatch = () => {
        const { batchMarkData, catalogId } = this.state;
        if (batchMarkData.length == 0) {
            return message.warning('请选择需要批量下载的文件')
        }
        const sendData = {};
        batchMarkData.map((el, index) => {
            sendData[`fileManageDownload[${index}].id`] = el.id;
            sendData[`fileManageDownload[${index}].source`] = el.source;
        });
        ExportUtil.export({ ...sendData, catalogId }, null, API_URL.folder.downloadFileBatch);
        message.success('正在下载中!');
    }

    preview = (id, fileName) => {
        const formatData = ["xlsx", "pdf", "doc", "png","docx"];
        const suffix = fileName.split('.').pop();
        if (formatData.some(el => el == suffix)) {
            message.success('文档加载中，请稍后', 0);
        } else {
            message.error('该文件格式不支持预览');
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.folder.previewFile,
            data: {
                id,
            },
            dataType: 'json',
            doneResult: res => {
                message.destroy();
                const { str } = res;
                //解析base64编码
                const base64Data = str.replace(/^data:.*?;base64,/, '')  // 去除 Data URL 前缀
                                        .replace(/[^A-Za-z0-9+/=]/g, '')    // 过滤非法字符
                                        .padEnd(str.length + (4 - (str.length % 4)) % 4, '='); // 补全填充符
                const binaryString = window.atob(base64Data);
                const byteArray = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    byteArray[i] = binaryString.charCodeAt(i);
                }
                //转化为blob对象，获取url
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const imageUrl = URL.createObjectURL(blob);
                window.open(`${imageUrl}`);
            },
            errorResult: () => {
                message.destroy();
            }
        };
        $.sendRequest(options);
    }

    downloadFile = (id, source, dataType) => {
        if (dataType === 'OSS') {
            // OSS下载方式
            // const options = {
            //     method: 'POST',
            //     url: API_URL.folder.downloadOssFile,
            //     data: {
            //         id,
            //     },
            //     dataType: 'json',
            //     doneResult: res => {
            //         const { url } = res;
            //         const link = document.createElement('a');
            //         link.href = url;
            //         link.download = this.getFileName(url); // 关键：设置文件名
            //         link.style.display = 'none';
                    
            //         // 插入DOM并触发点击
            //         document.body.appendChild(link);
            //         link.click();
                    
            //         // 清理DOM
            //         document.body.removeChild(link);
            //         message.success('正在下载中!');
            //     },
            // };
            // $.sendRequest(options);
            ExportUtil.export({ id }, null, API_URL.folder.downloadOssFile);
        } else {
            if (source === 'VITAE') {
                ExportUtil.export({ vitaeId: id, typeName: 'DOCX' }, null, API_URL.personal.downloadVitaeByType);
                ExportUtil.export({ vitaeId: id, typeName: 'PDF' }, null, API_URL.personal.downloadVitaeByType);
            } else if (source === 'MAJOR_EVENT') {
                ExportUtil.export({ majorEventId: id, fileFlag: 'FILE_FLAG' }, null, API_URL.execute.exportMajorEventWord);
            } else {
                ExportUtil.export({ id }, null, API_URL.folder.downloadFile);
            }
            message.success('正在下载中!');
        }
    }

    // 提取文件名（兼容URL编码和路径截取）
    getFileName = (url) => {
        // 去除查询参数和哈希部分
        const cleanUrl = url.split('?')[0].split('#')[0]; 
        // 获取最后一个路径段并解码中文
        const fileNameSegment = cleanUrl.split('/').pop(); 
        return decodeURIComponent(fileNameSegment);
    };

    deleteFileManage = (id) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.folder.deleteFileManage,
            data: {
                id,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false });
                this.queryTableData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    deleteCatalog = (id) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: <div style={{marginLeft: 42}}>确定要删除该文档分类吗？</div>,
            onOk: () => {
                const options = {
                    method: 'POST',
                    url: API_URL.folder.deleteCatalog,
                    data: {
                        id,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.loadData();
                    },
                };
                $.sendRequest(options);
            },
        });
    }

    onExpand = (expandedKeys) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }

    onSelect = (id, sonText, catalogType, parentId, createUser) => {
        const { treeData, pagination } = this.state;
        const path = this.findNodePath(treeData, id);
        const pathName = (path || []).map((node) => node.catalogName).join('-->');
        this.setState({
            pathName,
            sonText,
            pagination: {
                ...pagination,
                current: 1,
            },
            catalogId: id,
            catalogType,
            createUser, //用于判断目录是否预埋
            clearArry: true,
            batchMarkData: [],
        }, () => {
            this.queryTableData();
        })
    }

    // 递归查找节点路径
    findNodePath = (nodes, targetKey, path = []) => {
        for (const node of nodes) {
            const currentPath = [...path, node];
            if (node.id === targetKey) {
                return currentPath;
            }
            if (node.children) {
                const found = this.findNodePath(node.children, targetKey, currentPath);
                if (found) return found;
            }
        }
        return null;
    };

    onChange = (e) => {
        const { simplifyTreeData } = this.state;
        const value = e.target.value;
        const expandedKeys = [];
        simplifyTreeData.map(el => {
            if (el.catalogName.indexOf(value) > -1) {
                expandedKeys.push(String(el.id));
            }
        });
        this.setState({
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
        });
    }

    setTipTittle = (text) => {
        if (!text) {
            return ''
        }
        const arr = (text || "").split("\n");
        const tipTitle = (
            <div>
                <span style={{ color: 'yellow' }}>注意：自查要点</span><br />
                {arr.map(el => (
                    <span>
                        {el}
                        <br />
                    </span>
                ))}
            </div>
        );
        return tipTitle
    }

    getColumns = () =>{
        const { catalogType } = this.state;
        let columns = [];
        switch (catalogType) {
            case 'CHINESE_VITAE':
            case 'ENGLISH_VITAE':
            case 'VITAE':
                columns = [{
                    title: '文件名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '审批状态',
                    dataIndex: 'approvalStatusShow',
                    key: 'approvalStatusShow',
                    width: 80,
                }, {
                    title: '审批人员',
                    dataIndex: 'approvalUserName',
                    key: 'approvalUserName',
                    width: 80,
                }, {
                    title: '审批通过时间',
                    dataIndex: 'approvalTime',
                    key: 'approvalTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }];
                break;
            case 'INVESTIGATON_TRAINING':
            case 'COV_INVESTIGATON_LEVEL':
                columns = [ {
                    title: '项目简称',
                    dataIndex: 'invName',
                    key: 'invName',
                    width: 180,
                }, {
                    title: '文件名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 120,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }];
                break;
            case 'QC_INVESTIGATON_LEVEL':
                columns = [ {
                    title: '项目简称',
                    dataIndex: 'invName',
                    key: 'invName',
                    width: 150,
                }, {
                    title: '文件名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 90,
                    render: (text, record) => {
                        const { source } = record;
                        return source == 'MAJOR_EVENT' ? <a onClick={()=>this.skipMajorEvent(record)}>{text}</a> : text
                    }
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 70,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 80,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '涉及层面',
                    dataIndex: 'involveLevelShow',
                    key: 'involveLevelShow',
                    width: 70,
                }, {
                    title: '涉及中心',
                    dataIndex: 'involveSiteName',
                    key: 'involveSiteName',
                    width: 80,
                }, {
                    title: '事件处理结束与否',
                    dataIndex: 'isHandle',
                    key: 'isHandle',
                    width: 80,
                    render: text => text ? (text == '0' ? '否': '是') : ''
                }];
                break;
            default:
                columns = [{
                    title: '文件名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }];
                break;
        }
        columns.push({
            title: "操作",
            key: "operate",
            dataIndex: "operate",
            width: 100,
            render: (text, record) => {
                const { id, source, previewFlag, downloadFlag, approvalFlag, deleteFlag, dataType, fileName } = record;
                const { userId } = this.state; // userId有值的时候说明是从“人员文件夹”或“消息”进来的

                return (
                    <span>
                        {
                            previewFlag && <a onClick={() => this.preview(id, fileName)}>预览</a>
                        }
                        {
                            (previewFlag && approvalFlag && userId) && <span className="ant-divider" />  
                        }
                        {
                            (approvalFlag && userId) && <a onClick={() => this.ApproveVitaeModalRef.show(id)}>审批</a>  
                        }
                        {
                            (previewFlag && downloadFlag) && <span className="ant-divider" />
                        }
                        {
                            downloadFlag && <a onClick={() => this.downloadFile(id, source, dataType)}>下载</a>
                        }
                        {
                            (downloadFlag && (deleteFlag && !userId)) && <span className="ant-divider" />
                        }
                        {
                            (deleteFlag && !userId) && <Popconfirm title='确定要删除吗?' onConfirm={() => this.deleteFileManage(id)} okText="确定" cancelText="取消">
                                <a>删除</a>
                            </Popconfirm>
                        }
                    </span>
                );
            }
        });
        return columns
    } 

    skipMajorEvent = (record) => {
        const { involveLevel } = record;
        const setSession = {};
        if (involveLevel == 'SITE_LEVEL') {
            setSession.invId = record.invId;
            setSession.invName = record.invName;
            setSession.investigationSiteCode = record.involveSiteCode;
            setSession.investigationSiteName = record.involveSiteName;
            setSession.siteId = record.involveSite;
            setSession.majorEventNumber = record.fileName;
            this.setSession(setSession);
            location.href = `./#/execute/importantEvent`;

        } else {
            setSession.invId = record.invId;
            setSession.invName = record.invName;
            setSession.investigationSiteCode = "";
            setSession.investigationSiteName = "中心汇总";
            setSession.siteId = "";
            setSession.majorEventNumber = record.fileName;
            this.setSession(setSession);
            location.href = `./#/execute/importantEvent`;
        }
    }

    setSession = (setSession) => {
        if (Object.keys(setSession).length !== 0) {
            for (let [k, v] of Object.entries(setSession)) {
                sessionStorage[k] = v;
            }
        }
    }

    handleUploadChange = ({file, fileList}) => {
        const { response = {} } = file;
        if (response.error) {
            return  message.error(response.error);
        }
        if (file.status === 'done') {
            // 上传成功时触发表格刷新
            this.queryTableData();
            this.showUploadMessage('文件上传成功');
        } else if (file.status === 'error') {
            this.showUploadMessage('文件上传失败');
        }
        this.setState({ fileList });
    }

    beforeUpload = file => {
        const { maxSize } = this.state;
        const isLtM = (file.size / 1024 / 1024) < maxSize;
        if (!isLtM) {
            message.warning(`文件大小不能超过${maxSize}M`);
            return false;
        }
        this.showUploadMessage('正在上传中!');
    }

    timerId = null;

    showUploadMessage = (text) => {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
            message.success(text);
        }, 300);
    };

    onSelectChange = (record, selected) => {
        const { selectedRowKeys, arry, tableData, batchMarkData } = this.state;
        if (selected) {
            const isExist = selectedRowKeys.some(item => item == record.index);
            !isExist && selectedRowKeys.push(record.index);
            const isIdExist = arry.some(item => item == record.id);
            if (!isIdExist) {
                arry.push(record.id);
                tableData.map(el => {
                    if (el.id == record.id) {
                        batchMarkData.push({...el});
                    }
                });
            }
        } else {
            let idx;
            selectedRowKeys.forEach((item, index) => {
                if (record.index == item) {
                    idx = index;
                }
            });
            (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

            // 删除已存在的id
            let idIdx;
            arry.forEach((item, index) => {
                if (record.id == item) {
                    idIdx = index;
                }
            });
            if (idIdx || (!idIdx && idIdx === 0)) {
                arry.splice(idIdx, 1);
                batchMarkData.splice(idIdx, 1);
            }
        }
        this.setState({
            arry,
            selectedRowKeys,
            batchMarkData,
        });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        const { arry, selectedRowKeys, tableData, batchMarkData } = this.state;
        if (selected) {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                !(idx || (!idx && idx === 0)) && selectedRowKeys.push(item.index);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.id) {
                        idIdx = index;
                    }
                });
                if (!(idIdx || (!idIdx && idIdx === 0))) {
                    arry.push(item.id);
                    tableData.map(el => {
                        if (el.id == item.id) {
                            batchMarkData.push({...el});
                        }
                    });
                }
            });
        } else {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.id) {
                        idIdx = index;
                    }
                });
                if (idIdx || (!idIdx && idIdx === 0)) {
                    arry.splice(idIdx, 1);
                    batchMarkData.splice(idIdx, 1);
                }
            });
        }
        this.setState({
            arry,
            selectedRowKeys,
            batchMarkData,
        });
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
            clearArry: false,
        }, () => {
            this.queryTableData();
        });
    }

    skip = (catalogType) => { 
        const { userId, userName } = this.state;
        let path = '';
        switch (catalogType) {
            case 'CHINESE_VITAE':
            case 'JD_CHILD':
                if (userId) {
                    this.props.saveParams({
                        userId,
                        userName,
                        isChinese: true,
                    });
                    location.href = `./#/user/curriculumVitae`;
                } else {
                    this.props.saveParams({ isChinese: true });
                    path = './#/personal/curriculumVitae';
                }
                break;
            case 'ENGLISH_VITAE':
                if (userId) {
                    this.props.saveParams({
                        userId,
                        userName,
                        isChinese: false,
                    });
                    location.href = `./#/user/curriculumVitae`;
                } else {
                    this.props.saveParams({ isChinese: false });
                    path = './#/personal/curriculumVitae';
                }
                break;
            case 'TEACH_SUPERVISOR_MANAGER':
                path = './#/teaching/management';
                break;
        }
        if (path)location.href = path;
    }

    leave = () => {
        location.href = `./#/user/userFolder`;
    }

    render() {
        const {
            treeData,
            tableData,
            loading,
            pagination,
            searchValue = '',
            expandedKeys,
            autoExpandParent,
            fileList,
            catalogId,
            catalogType,
            selectedRowKeys,
            pathName,
            userId,
        } = this.state;
        const loop = data => (data || []).map(item => {
            const { id, catalogName, createUser, catalogDesc, catalogIndex, catalogType, parentId } = item;
            const isSearch = searchValue ? catalogName.includes(searchValue) : false;
            const fontContent = catalogName;

            const tipTitle = this.setTipTittle(catalogDesc);
            
            const title =
                <div className='catalog_content' style={{ marginTop: catalogIndex == 1 ? -6 : 0, backgroundColor: isSearch ? '#cfe8fc': undefined }}>
                    {
                        catalogIndex == 1 ? <span style={{ display: 'flex', alignItems: 'center' }}>
                            <i className="icon iconfont" style={{ marginRight: 3, fontSize: '22px', color: '#5959df' }}>&#xe6cf;</i>
                            {fontContent}
                        </span> : <span 
                                style={{ display: 'flex' }}
                                onClick={() => this.onSelect(id, catalogName, catalogType, parentId, createUser)}
                            >
                            <Icon type="folder-open" style={{ marginRight: 3, color: '#5959df' }} />
                            {fontContent}
                        </span> 
                    }
                    {
                        (createUser != -1 && !userId) && <span onClick={() => this.UpdateCatalogRef.show('edit', id, catalogName, catalogDesc)} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="edit" /></span>
                    }
                    {
                        (createUser != -1 && !userId) && <span onClick={() => this.deleteCatalog(id)} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="minus-circle-o" /></span>
                    }
                    {
                        (catalogIndex != 5 && !userId) && <span onClick={() => this.UpdateCatalogRef.show('add', id )} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="plus-circle-o" /></span>
                    }
                    {
                        !!tipTitle && <Tooltip placement="right" overlayClassName="head_tip" title={tipTitle}>
                            <a className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="info-circle" /></a>
                        </Tooltip>
                    }

                </div>;
            return (
                <TreeNode key={String(item.id)} title={title}>
                    {loop(item.children)}
                </TreeNode>
            );
        });

        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
            getCheckboxProps: record => ({
                disabled: !record.batchDownloadFlag,
            }),
        };

        const canSkip = catalogType == 'CHINESE_VITAE' || catalogType == 'ENGLISH_VITAE' || catalogType == 'JD_CHILD' || catalogType == 'TEACH_SUPERVISOR_MANAGER';

        const formatLimitation = catalogType == 'CHINESE_VITAE' || catalogType == 'ENGLISH_VITAE' || catalogType == 'JD_CHILD';

        return (
            <div className="content">
                { !!userId ? <UserSider selectKey='userFolder' openKeys={['sub1']}/> : <SideNav selectKey='file' />}
                <div className="main">
                    <div className='file_content'>
                        <div className='left'>
                            <span>
                                <Select 
                                    style={{ marginBottom: 8, width: 70 }}
                                    defaultValue={'文件夹'}
                                >
                                    <Option value={'文件夹'}>{'文件夹'}</Option>
                                </Select>
                                <Search style={{ marginBottom: 8, width: 240 }} placeholder="请输入" onChange={this.onChange} />
                            </span>
                            <Tree
                                showLine
                                onExpand={this.onExpand}
                                expandedKeys={expandedKeys}
                                autoExpandParent={autoExpandParent}
                            >
                                {loop(treeData)}
                            </Tree>
                        </div>
                        <div className='right'>
                            {
                                !!userId && <div
                                    style={{
                                        float: "right",
                                        margin: "0px 20px",
                                        color: "#1296DB",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => this.leave()}
                                >
                                    <i
                                        className="icon iconfont"
                                        style={{ marginRight: 4, fontSize: "20px" }}
                                    >
                                        &#xe63d;
                                    </i>
                                    返回
                                </div>
                            }
                            <div className='table_top'>
                                <div className='top_left'>
                                    <Icon style={{ marginRight: 5 }} type="environment-o" />
                                    {
                                        canSkip ? <a onClick={() => this.skip(catalogType)}>{pathName}</a> : pathName
                                    }
                                </div>
                                <div className='top_right'>
                                    <Button key="downloadFileBatch" type="primary" onClick={this.downloadFileBatch}>批量下载</Button>

                                    {
                                        (!(catalogType == 'INVESTIGATON_TRAINING' || catalogType == 'COV_INVESTIGATON_LEVEL' || catalogType == 'QC_INVESTIGATON_LEVEL') && !userId) &&
                                            <Upload
                                                key="uploadFile"
                                                data={{
                                                    curUserId: sessionStorage.userId,
                                                    catalogId,
                                                }}
                                                accept={formatLimitation ? '.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document' : undefined}
                                                showUploadList={false}
                                                multiple={true} 
                                                action={API_URL.folder.uploadFile}
                                                beforeUpload={this.beforeUpload}
                                                onChange={this.handleUploadChange}
                                                fileList={fileList}
                                                headers={xToken}
                                            >
                                                <Button style={{ marginLeft: 20 }} type="primary" >上传文件</Button>
                                            </Upload>
                                    }
                                    
                                </div>

                            </div>
                            <Table
                                bordered
                                rowSelection={rowSelection}
                                rowKey={record => record.index}
                                scroll={{ x: 500 }}
                                pagination={pagination}
                                dataSource={tableData}
                                loading={loading}
                                columns={this.getColumns()}
                                onChange={this.handleTableChange}
                            />
                        </div>
                    </div>
                        <UpdateCatalog ref={el => this.UpdateCatalogRef = el} loadData={this.loadData} />

                        <ApproveVitaeModal ref={el => this.ApproveVitaeModalRef = el} queryTableData={this.queryTableData} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        params: state.personalState.params,
        noticeParams: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveNoticeParams: (params) => dispatch(saveNoticeParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(File);





// WEBPACK FOOTER //
// ./src/components/personal/file/index.js